import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HisBackendService } from 'hisng';

import { Habilitation } from '../model/habilitation';


@Injectable()
export class HabilitationService {

    constructor( private backendService: HisBackendService ) { }

    /**
     * get habilitation by id from database
     *
     * @param id of habilitation
     */
    getHabilitationById( id: number ): Observable<Habilitation> {
        return this.backendService.getData( `api/v1/fs/res/habilitation/${id}` );
    }

    /**
     * save habilitaion in database
     *
     * @param habilitation to save
     */
    saveHabilitation( habilitation: Habilitation ): Observable<Habilitation> {
        if ( habilitation.id ) {
            return this.backendService.putData( `api/v1/fs/res/habilitation/${habilitation.id}`, habilitation );
        } else {
            return this.backendService.postData( 'api/v1/fs/res/habilitation', habilitation );
        }
    }

    /**
     * delete habilitation with given id from database
     *
     * @param id of habilitation to delete
     * @return Observable.of( 0=fail / 1=success )
     */
    deleteHabilitation( id: number ): Observable<number> {
        return this.backendService.delete( `api/v1/fs/res/habilitation/${id}` );
    }

    /**
     * get habilitations (doctorates) by text from database
     *
     * @param searchText contained in habilitation
     */
    getValues( searchText: string ): Observable<Habilitation[]> {
        let doctorateTypes$ = null; // this.backendService.getData( `api/v1/fs/res/habilitation?q=${encodeURI(searchText)}` );
        return doctorateTypes$;
    }

}
